if (!customElements.get('locations-section')) {
  class LocationsSection extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll('.locations__item');
      this.images = this.querySelectorAll('.locations__image');
    }

    connectedCallback() {
      this.items.forEach((item) => {
        const button = item.querySelector('.locations__item-header');
        button.addEventListener('click', () => this.activate(item));
      });
    }

    activate(activeItem) {
      const index = activeItem.dataset.index;

      this.items.forEach((item) => {
        const isActive = item === activeItem;
        item.classList.toggle('is-active', isActive);
        item.querySelector('.locations__item-header').setAttribute('aria-expanded', isActive);
      });

      this.images.forEach((image) => {
        image.classList.toggle('is-active', image.dataset.index === index);
      });
    }
  }

  customElements.define('locations-section', LocationsSection);
}
